export const SHOW_GIT_OVERLAY = "SHOW_GIT_OVERLAY";
export const SET_BOUGHT_VIDEO = "SET_BOUGHT_VIDEO";
export const SET_CURRENT_VIDEOS = "SET_CURRENT_VIDEOS";
